import { lazy } from "react";
import { Navigate } from "react-router-dom";
// ===========================================================================
// High Cost — módulo independiente.
//
// "Sala de control" del gasto: pestañas Patients/Analysis. El detalle del
// paciente es un PANEL en memoria que se abre desde la tabla (doc 27) — con
// cabecera, tabs de AdvancedMD protegidos por el estado del vínculo,
// vinculación manual y observaciones. Controlador backend: /api/HighCost.
// Reemplaza al High Cost viejo de clinical-info (/clinical-info/high-cost,
// que ahora redirige aquí).
// ===========================================================================
const HighCostPage = lazy(() => import("./pages/HighCostPage"));
export const highCostRoutes = [
  { path: "/high-cost", element: <HighCostPage /> },
  // La ficha por URL (/high-cost/:cipId) se retiró: dejaba el CIP en el
  // historial del navegador (doc 27 §8). Los enlaces viejos vuelven a la lista.
  { path: "/high-cost/:cipId", element: <Navigate to="/high-cost" replace /> },
];

export * from "./services";
export default HighCostPage;
